import { IGetVenuesResponseData } from 'src/api/getVenues/types';
import { IAggregator } from 'src/types/menu.types';
import { IPublishVenue } from '../../../components/PublishModal/types';

export const getVenuesToPublishTo = (
  venues: IGetVenuesResponseData[],
  channelId: string,
  aggregator: IAggregator | undefined,
  isTrial: boolean,
): IPublishVenue[] =>
  venues
    .filter((venue: IGetVenuesResponseData) => isTrial === venue.is_trial)
    .filter((venue: IGetVenuesResponseData) =>
      venue.external_identifiers?.some((identifier) => identifier.external_system_id === channelId),
    )
    .map((venue: IGetVenuesResponseData) => {
      const venueStatus = aggregator?.venues?.find((v) => venue.venue_id === v.venueId);
      return {
        name: venue.name,
        venue_id: venue.venue_id,
        is_trial: venue.is_trial,
        ...(venueStatus && {
          priceSchemeName: venueStatus.priceSchemeName,
          publicationDate: venueStatus.publicationDate,
          publicationStatus: venueStatus.publicationStatus,
        }),
      };
    });
